import React, { useEffect, useState } from "react";
import { Ic, DomainTag, btnPrimary, showStyledAlert } from "../components/UI";
import { addActivity } from "../utils/firestore";
import { ActivityFormModal } from "./ActivitiesPage";
import { formatContributionCurrency, getActivityContributionSummary, getActivityContributionValueTotal, sumActivitiesContributionTotal, sumActivitiesContributionValueTotal } from "../utils/activityContributions";

function useMaps(volunteers, domains) {
  const volMap = {};
  volunteers.forEach((v) => {
    volMap[v.id] = v;
  });
  const domMap = {};
  domains.forEach((d) => {
    domMap[d.id] = d;
  });
  return { volMap, domMap };
}

export default function PortalPage({ volunteer, domains, activities, recurring, beneficiaries, contributionTypes = [], onRefresh, showToast, userId, isMobile = false, addOpenToken = 0 }) {
  const [modal, setModal] = useState(false);
  const { domMap } = useMaps([], domains);

  useEffect(() => {
    if (addOpenToken > 0) setModal(true);
  }, [addOpenToken]);

  if (!volunteer) {
    return <div style={{ background: "white", border: "1px solid #E8E8E8", borderRadius: 14, padding: 24 }}>לא נמצא פרופיל מתנדב. פנה לרכז לשיוך חשבון.</div>;
  }

  const myActs = activities.filter((a) => a.volunteerId === volunteer.id).sort((a, b) => (b.date || "").localeCompare(a.date || ""));
  const myRecurring = recurring.filter((r) => r.volunteerId === volunteer.id && r.status === "active");
  const totalHours = myActs.reduce((s, a) => s + Number(a.duration || 0), 0);
  const totalContributions = sumActivitiesContributionTotal(myActs);
  const totalContributionValue = sumActivitiesContributionValueTotal(myActs);

  const saveActivity = async (form) => {
    try {
      await addActivity({ ...form, volunteerId: volunteer.id, source: "manual" }, userId);
      showToast("הדיווח נשמר");
      setModal(false);
      onRefresh();
    } catch (e) {
      await showStyledAlert("שגיאה בשמירת דיווח: " + e.message);
    }
  };

  return (
    <div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(180px,1fr))", gap: 10, marginBottom: 14 }}>
        <div style={{ background: "white", border: "1px solid #E8E8E8", borderRadius: 12, padding: 14 }}><div style={{ fontSize: 12, color: "#737373" }}>סה"כ פעילויות</div><div style={{ fontFamily: "Assistant", fontSize: 24, fontWeight: 800 }}>{myActs.length}</div></div>
        <div style={{ background: "white", border: "1px solid #E8E8E8", borderRadius: 12, padding: 14 }}><div style={{ fontSize: 12, color: "#737373" }}>סה"כ שעות</div><div style={{ fontFamily: "Assistant", fontSize: 24, fontWeight: 800 }}>{totalHours.toFixed(1)}</div></div>
        <div style={{ background: "white", border: "1px solid #E8E8E8", borderRadius: 12, padding: 14 }}><div style={{ fontSize: 12, color: "#737373" }}>סה"כ תרומות</div><div style={{ fontFamily: "Assistant", fontSize: 24, fontWeight: 800 }}>{totalContributions}</div></div>
        <div style={{ background: "white", border: "1px solid #E8E8E8", borderRadius: 12, padding: 14 }}><div style={{ fontSize: 12, color: "#737373" }}>שווי תרומות</div><div style={{ fontFamily: "Assistant", fontSize: 24, fontWeight: 800 }}>{formatContributionCurrency(totalContributionValue) || "—"}</div></div>
        <div style={{ background: "white", border: "1px solid #E8E8E8", borderRadius: 12, padding: 14 }}><div style={{ fontSize: 12, color: "#737373" }}>פעילויות קבועות</div><div style={{ fontFamily: "Assistant", fontSize: 24, fontWeight: 800 }}>{myRecurring.length}</div></div>
      </div>

      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 12 }}>
        <button style={btnPrimary} onClick={() => setModal(true)}><Ic.Plus />דיווח פעילות</button>
      </div>

      <div style={{ background: "white", borderRadius: 14, border: "1px solid #E8E8E8", overflowX: "auto", marginBottom: 16 }}>
        {!isMobile ? <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 760 }}>
          <thead><tr>{["תאריך", "שעה", "תחום", "משך", "תרומות", "שווי", "הערות"].map((h) => <th key={h} style={{ padding: "12px 16px", fontSize: 12, fontWeight: 600, color: "#737373", textAlign: "right", background: "#FAFAFA", borderBottom: "1px solid #E8E8E8" }}>{h}</th>)}</tr></thead>
          <tbody>
            {myActs.slice(0, 30).map((a) => (
              <tr key={a.id}>
                <td style={{ padding: "12px 16px", borderBottom: "1px solid #F5F5F5" }}>{a.date || ""}</td>
                <td style={{ padding: "12px 16px", borderBottom: "1px solid #F5F5F5" }}>{a.time || ""}</td>
                <td style={{ padding: "12px 16px", borderBottom: "1px solid #F5F5F5" }}>{domMap[a.domainId] ? <DomainTag domain={domMap[a.domainId]} /> : "—"}</td>
                <td style={{ padding: "12px 16px", borderBottom: "1px solid #F5F5F5" }}>{Number(a.duration || 0)}</td>
                <td style={{ padding: "12px 16px", borderBottom: "1px solid #F5F5F5", color: "#9A3412" }}>{getActivityContributionSummary(a) || "—"}</td>
                <td style={{ padding: "12px 16px", borderBottom: "1px solid #F5F5F5", color: "#0F766E", fontWeight: 700 }}>{formatContributionCurrency(getActivityContributionValueTotal(a)) || "—"}</td>
                <td style={{ padding: "12px 16px", borderBottom: "1px solid #F5F5F5" }}>{a.notes || ""}</td>
              </tr>
            ))}
            {myActs.length === 0 && <tr><td colSpan={7} style={{ textAlign: "center", padding: 28, color: "#A3A3A3" }}>עדיין אין דיווחים</td></tr>}
          </tbody>
        </table> : <div style={{ padding: 12, display: "flex", flexDirection: "column", gap: 10 }}>
          {myActs.slice(0, 30).map((a) => (
            <div key={a.id} style={{ border: "1px solid #E8E8E8", borderRadius: 10, padding: 10 }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 5 }}>
                <div style={{ fontWeight: 700 }}>{a.date || ""}</div>
                <div style={{ fontSize: 12, color: "#737373" }}>{a.time || ""}</div>
              </div>
              <div style={{ marginBottom: 4 }}>{domMap[a.domainId] ? <DomainTag domain={domMap[a.domainId]} /> : "—"}</div>
              <div style={{ fontSize: 12, color: "#737373", marginBottom: 4 }}>{Number(a.duration || 0)} שעות</div>
              {getActivityContributionSummary(a) && <div style={{ fontSize: 12, color: "#9A3412", marginBottom: 4 }}>תרומות: {getActivityContributionSummary(a)}</div>}
              {getActivityContributionValueTotal(a) > 0 && <div style={{ fontSize: 12, color: "#0F766E", marginBottom: 4, fontWeight: 700 }}>שווי: {formatContributionCurrency(getActivityContributionValueTotal(a))}</div>}
              {a.notes && <div style={{ fontSize: 12, color: "#525252" }}>{a.notes}</div>}
            </div>
          ))}
          {myActs.length === 0 && <div style={{ textAlign: "center", padding: 28, color: "#A3A3A3" }}>עדיין אין דיווחים</div>}
        </div>}
      </div>

      <div style={{ background: "white", borderRadius: 14, border: "1px solid #E8E8E8", padding: 16 }}>
        <div style={{ fontFamily: "Assistant", fontSize: 18, fontWeight: 700, marginBottom: 8 }}>הנעזרים שלי</div>
        {beneficiaries.length === 0 && <div style={{ color: "#737373", fontSize: 14 }}>אין נעזרים משויכים כרגע.</div>}
        {beneficiaries.length > 0 && (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(220px,1fr))", gap: 10 }}>
            {beneficiaries.map((b) => (
              <div key={b.id} style={{ border: "1px solid #E8E8E8", borderRadius: 10, padding: 10 }}>
                <div style={{ fontWeight: 700, marginBottom: 4 }}>{b.name || "ללא שם"}</div>
                <div style={{ fontSize: 13, color: "#737373" }}>{b.city || ""}</div>
                <div style={{ fontSize: 13, color: "#737373" }}>{b.phone || ""}</div>
              </div>
            ))}
          </div>
        )}
      </div>

      {modal && <ActivityFormModal volunteers={[volunteer]} domains={domains} beneficiaries={beneficiaries} contributionTypes={contributionTypes} onClose={() => setModal(false)} onSave={saveActivity} />}
    </div>
  );
}
